import './FooterNav.css';

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { fetchCoursesAvailable } from '../../api/CourseAPI.js';
import { fetchResourcesAvailable } from '../../api/ResourceAPI.js';
import { fetchTrainingsAvailable } from '../../api/TrainingAPI.js';
import LanguageDropdown from '../dropdown/LanguageDropdown.js';

function FooterNav() {
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem('language');

  const [coursesAvailable, setCoursesAvailable] = useState(false);
  const [trainingsAvailable, setTrainingsAvailable] = useState(false);
  const [resourcesAvailable, setResourcesAvailable] = useState({});

  const hasAnyResource = Object.values(resourcesAvailable).some(
    (value) => value === true
  );

  useEffect(() => {
    fetchCoursesAvailable().then(setCoursesAvailable);
    fetchTrainingsAvailable().then(setTrainingsAvailable);
    fetchResourcesAvailable().then(setResourcesAvailable);
  }, []);

  if (selectedLanguage === 'pt') {
    return (
      <div className="footer-nav">
        <footer>
          <FooterNavItem header="Eventos" className="footer-desktop-only">
            <Link to="/events?when=future">Próximos Eventos</Link>
            <Link to="/events?when=past">Eventos Anteriores</Link>
            <Link to="/events?when=archived">Arquivo</Link>
          </FooterNavItem>

          <FooterNavItem header="Cursos Online" className="footer-desktop-only">
            <Link to="/courses?when=future">Próximos Cursos</Link>
            <Link to="/courses?when=past">Cursos Anteriores</Link>
            <Link to="/courses?when=archived">Arquivo</Link>
          </FooterNavItem>

          <FooterNavItem header={t('header.trainings')} className="footer-desktop-only">
            <Link to="/trainings">{t('trainings.next_trainings')}</Link>
          </FooterNavItem>

          <FooterNavItem header={t('header.resources')} className="footer-desktop-only">
            <Link to="/resources/calculators">
              {t('resources.calculators')}
            </Link>
            <Link to="/resources/tables">
              {t('resources.conversion_tables')}
            </Link>
            <Link to="/resources/trees">{t('resources.decision_trees')}</Link>
            <Link to="/resources/guidelines">{t('resources.guidelines')}</Link>
            <Link to="/resources/infos">{t('resources.infographics')}</Link>
            <Link to="/resources/leaflets">{t('resources.sheets')}</Link>
            <Link to="/resources/exercises">{t('resources.exercises')}</Link>
          </FooterNavItem>

          <FooterNavItem header="Parceiros" className="footer-desktop-only">
            <Link to="/partner-contact">Parcerias</Link>
          </FooterNavItem>

          <div className="footer-mobile-only footer-mobile-titles">
            <Link to="/resources/calculators" className="footer-mobile-title">{t('header.resources')}</Link>
            <Link to="/trainings" className="footer-mobile-title">{t('header.trainings')}</Link>
            <Link to="/courses?when=future" className="footer-mobile-title">Cursos Online</Link>
            <Link to="/events?when=future" className="footer-mobile-title">Eventos</Link>
            <Link to="/partner-contact" className="footer-mobile-title">Parceiros</Link>
          </div>

          <div className="footer-mobile-only footer-mobile-language">
            <LanguageDropdown menuPlacement="top" width="100%" />
          </div>

          <LanguageDropdown menuPlacement="top" />
        </footer>
      </div>
      // Next
    );
  } else {
    return (
      <div className="footer-nav">
        <footer>
          {/* Desktop items */}
          {coursesAvailable && (
            <FooterNavItem header={t('header.online_courses')} className="footer-desktop-only">
              <Link to="/courses?when=future">{t('home.next_courses2')}</Link>
              <Link to="/courses?when=past">
                {t('courses.previous_courses')}
              </Link>
              <Link to="/courses?when=archived">{t('courses.archive')}</Link>
            </FooterNavItem>
          )}

          {trainingsAvailable && (
            <FooterNavItem header={t('header.trainings')} className="footer-desktop-only">
              <Link to="/trainings">{t('trainings.next_trainings')}</Link>
            </FooterNavItem>
          )}

          {hasAnyResource && (
            <FooterNavItem header={t('header.resources')} className="footer-desktop-only">
              {resourcesAvailable?.calculators && (
                <Link to="/resources/calculators">
                  {t('resources.calculators')}
                </Link>
              )}
              {resourcesAvailable?.tables && (
                <Link to="/resources/tables">
                  {t('resources.conversion_tables')}
                </Link>
              )}
              {resourcesAvailable?.trees && (
                <Link to="/resources/trees">
                  {t('resources.decision_trees')}
                </Link>
              )}{' '}
              {resourcesAvailable?.guidelines && (
                <Link to="/resources/guidelines">
                  {t('resources.guidelines')}
                </Link>
              )}
              {resourcesAvailable?.infos && (
                <Link to="/resources/infos">{t('resources.infographics')}</Link>
              )}{' '}
              {resourcesAvailable?.leaflets && (
                <Link to="/resources/leaflets">{t('resources.sheets')}</Link>
              )}{' '}
              {resourcesAvailable?.bodyparts && (
                <Link to="/resources/exercises">
                  {t('resources.exercises')}
                </Link>
              )}{' '}
            </FooterNavItem>
          )}

          <div className="footer-mobile-only footer-mobile-titles">
            {hasAnyResource && (
              <Link to="/resources/calculators" className="footer-mobile-title">{t('header.resources')}</Link>
            )}
            {trainingsAvailable && (
              <Link to="/trainings" className="footer-mobile-title">{t('header.trainings')}</Link>
            )}
            {coursesAvailable && (
              <Link to="/courses?when=future" className="footer-mobile-title">{t('header.online_courses')}</Link>
            )}
          </div>

          <div className="footer-mobile-only footer-mobile-language">
            <LanguageDropdown menuPlacement="top" width="100%" />
          </div>

          <LanguageDropdown menuPlacement="top" />
        </footer>
      </div>
      // Next
    );
  }
}

const FooterNavItem = (props) => (
  <div className={`footer-nav-item ${props.className || ''}`}>
    <h2>{props.header}</h2>
    {props.children}
  </div>
);

export default FooterNav;
